module.exports = __webpack_public_path__ + "3e8de7d48d318c3999981cb82283f6a2.MP3";